export default "__VITE_ASSET__Dmi6WRjr__"